import { render, staticRenderFns } from "./DialogViewCertificate.vue?vue&type=template&id=2dd6c1a5&"
import script from "./DialogViewCertificate.vue?vue&type=script&lang=js&"
export * from "./DialogViewCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DialogViewCertificate.vue?vue&type=style&index=0&id=2dd6c1a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports